$(() => {
  const URL = 'v1/product-analog-sorting';
  const containerAnalog = document.querySelector('.product-analog-container');
  if (containerAnalog === null) {
    return;
  }
  const JContainer = $(containerAnalog);

  const loaderFactory = function (container) {
    let loading = null;
    const jWindow = $(window);

    const positionLoading = function () {
      const contentTopOffset = container.offset().top;
      let contentLeftOffset = container.offset().left;

      contentLeftOffset = contentLeftOffset > 0 ? contentLeftOffset : contentLeftOffset * -2;
      const contentHeight = container.height();
      const contentWidth = container.width();
      const scrollTop = jWindow.scrollTop();
      const windowHeight = jWindow.height();
      let topWindowOffset = contentTopOffset - scrollTop;
      if (topWindowOffset < 0) {
        topWindowOffset = 0;
      }

      let bottomWindowOffset = contentTopOffset + contentHeight - scrollTop;
      if (bottomWindowOffset > windowHeight) {
        bottomWindowOffset = windowHeight;
      }
      const topPosition = (bottomWindowOffset - topWindowOffset) / 2 + topWindowOffset;
      const leftPosition = contentWidth / 2 + contentLeftOffset;

      loading.css({ left: `${leftPosition}px`, top: `${topPosition}px` });
    };

    const appendLoading = function () {
      let zIndex = parseInt(container.css('z-index'), 10);
      if (Number.isNaN(zIndex)) {
        zIndex = 0;
      }
      zIndex += 1;
      loading = $('<img src="/images/common/loaders/loading-red.svg" alt="" />');
      loading.css({
        position: 'fixed',
        zIndex,
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        borderRadius: '64px',
        width: '64px',
        height: '64px',
        marginLeft: '-32px',
        marginTop: '-32px',
      });
      loading.appendTo(document.body);
      positionLoading();
      jWindow.on('scroll', positionLoading);
    };

    const removeLoading = function () {
      if (loading) {
        loading.remove();
      }
      jWindow.off('scroll', positionLoading);
    };

    return {
      start: appendLoading,
      stop: removeLoading,
    };
  };

  const loader = loaderFactory(JContainer);

  const initSorting = () => {
    const select2 = document.querySelector('.sorting #products-sort');
    showMoreToggle();
    $(select2).on('change', (e) => {
      const select = e.target;
      const data = JSON.parse(select.value);
      const isOpened = $('[data-show-more]').hasClass('show-more-opened');

      containerAnalog.querySelectorAll('.sorting #products-sort option').forEach((el) => {
        el.disabled = true;
      });
      JContainer.css({ opacity: 0.4 });
      loader.start();

      window.axios
        .post(URL, data)
        .then((response) => {
          JContainer.html(response.data);
          JContainer.css({ opacity: 1 });
          loader.stop();
          listenPreOrderButton();
          initSorting();
          $(JContainer).find('#products-sort').select2({
            dropdownAutoWidth: true,
            width: 'auto',
            minimumResultsForSearch: -1,
          });

          if (isOpened) $('[data-show-more]').addClass('show-more-opened');
        })
        .catch(() => {
          JContainer.hide();
          document.modalMessageErrorShow();
        });
    });
  };

  initSorting();

  function listenPreOrderButton() {
    Array.prototype.filter.call(document.querySelectorAll('.btn-pre-order'), (button) => {
      button.onclick = (e) => {
        const el = e.currentTarget.querySelector('button');
        const modal = document.querySelector(el.dataset.target);
        modal.querySelector('input#order-items-product-id').value = Number(el.dataset.productId);
      };
    });
  }

  function showMoreToggle() {
    const blocks = document.querySelectorAll('[data-show-more]');

    [...blocks].forEach((block) => {
      const header = block.parentElement.querySelector('.section-title');
      const button = block.parentElement.querySelector('.section-cta');

      button?.addEventListener('click', (e) => {
        e.preventDefault();
        if (block.classList.contains('show-more-opened')) {
          $('html, body').animate(
            {
              scrollTop: $(header).offset().top - $('.header-box').height(),
            },
            0,
          );
          block.classList.toggle('show-more-opened');
          button.innerHTML = '<span>Показать все</span>';
        } else {
          block.classList.toggle('show-more-opened');
          button.innerHTML = '<span>Скрыть</span>';
        }
      });
    });
  }
});
